import { EnhancedHeader } from '@/components/EnhancedHeader';
import { ResponsibleGaming } from '@/components/ResponsibleGaming';

export default function SafeGaming() {
  return (
    <div className="min-h-screen bg-gradient-dark">
      <EnhancedHeader />
      <main className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2">Responsible Gaming</h1>
          <p className="text-muted-foreground">
            Stay in control of your betting with our safety tools
          </p>
        </div>
        <ResponsibleGaming />
      </main>
    </div>
  );
}
